import React from "react";
import { Check } from "lucide-react";
import { STEP_LABELS, getStepClassName } from "./constants";

export default function ProgressSteps({ step }) {
  return (
    <div className="flex items-center justify-center gap-2 mb-12">
      {STEP_LABELS.map((label, idx) => (
        <div key={label} className="flex items-center gap-2">
          <div className={`w-8 h-8 flex items-center justify-center text-xs font-semibold transition-all duration-300 rounded-full ${getStepClassName(step, idx)}`}>
            {step > idx + 1 ? <Check size={14} /> : idx + 1}
          </div>
          <span className={`text-xs tracking-wider hidden sm:inline ${step === idx + 1 ? "text-emerald_deep" : "text-text_muted/50"}`}>{label}</span>
          {idx < STEP_LABELS.length - 1 && <div className={`w-8 h-px ${step > idx + 1 ? "bg-emerald_deep" : "bg-border_custom"}`}></div>}
        </div>
      ))}
    </div>
  );
}
